import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";

export const getMapToken = async (): Promise<string> =>
    await apiClient
        .get<string>("/map-tokens")
        .then((response) => response.data)
        .catch(handleAxiosError);
